const handleNavClick = (href: string) => {
  const el = document.querySelector(href);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="text-xl font-heading font-bold text-background-50 mb-4 block">
              91吃瓜
            </span>
            <p className="text-sm text-foreground-400 leading-relaxed">
              全网最活跃的吃瓜群众聚集地。200万+用户信赖的热点追踪与互动交流平台，每日更新海量真实爆料与深度讨论。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '平台特色', href: '#features' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">内容频道</h4>
            <ul className="space-y-2">
              {['娱乐八卦', '社会热点', '科技财经', '体育电竞', '网红直播'].map((item) => (
                <li key={item}>
                  <a
                    href="#index"
                    onClick={(e) => { e.preventDefault(); handleNavClick('#index'); }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                <a href="mailto:tougao@91chigua.com" className="hover:text-primary-400 transition-colors">
                  tougao@91chigua.com
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                7×24小时内容审核
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8">
          <div className="mb-6">
            <h4 className="text-xs font-bold text-background-400 mb-3 uppercase tracking-wider">合作伙伴</h4>
            <p className="text-xs text-foreground-500">
              合作伙伴信息即将上线，敬请期待
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2024-2026 91吃瓜 版权所有 | 吃瓜群众社区
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#faq"
                onClick={(e) => { e.preventDefault(); handleNavClick('#faq'); }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors"
              >
                常见问题
              </a>
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); handleNavClick('#about'); }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors"
              >
                关于我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}